module.exports = __webpack_public_path__ + "static/media/coder.44271347.svg";